import { Expose } from "class-transformer";

export interface ISessionDto {
  id: string;

  isActive: boolean;
}

export class SessionDto implements ISessionDto {
  @Expose()
  public id!: string;

  @Expose()
  public isActive!: boolean;
}
